export const MAX_PAYMENT_PERIOD_YEARS = 50;
export const PAYMENT_PERIOD_RANGE_MESSAGE = `返済年数は半角数字で1〜${MAX_PAYMENT_PERIOD_YEARS}年の整数で入力してください（借入なしの場合は0年も入力できます）。`;

export const getPaymentPeriodError = (
  period: string | number | null | undefined,
  loanAmount: string | number | undefined
): string | undefined => {
  const value = String(period ?? "");
  const years = Number(value);
  const hasLoan = Number(String(loanAmount ?? "0").replace(/,/g, "")) > 0;
  if (!/^\d+$/.test(value) || !Number.isInteger(years) || years < (hasLoan ? 1 : 0) || years > MAX_PAYMENT_PERIOD_YEARS) {
    return PAYMENT_PERIOD_RANGE_MESSAGE;
  }
  return undefined;
};
